// extracted by mini-css-extract-plugin
export default {"item":"styles_item__V2B-G","item_link":"styles_item_link__nC1Yp","block":"styles_block__6ogVl"};